export const deliverableChipStyles = {
  backgroundColor: 'rgba(238, 238, 238, 1)',
  color: '#757575',
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '14px',
  textTransform: 'uppercase',
  '& .MuiChip-label': {
    fontSize: '10px',
    fontWeight: 600,
    lineHeight: '14px',
  },
} as const;


